import { pages } from "src/utils/pages";

const keyRedirectUrl = "redirect-url";

export const getSessionStorageItem = (key: string) => sessionStorage.getItem(key);

export const setSessionStorageItem = (key: string, value: string) =>
  sessionStorage.setItem(key, value);

export const deleteSessionStorageItem = (key: string) => sessionStorage.removeItem(key);

export const clearSessionStorage = () => {
  sessionStorage.clear();
};

export const getRedirectUrl = () => getSessionStorageItem(keyRedirectUrl);

export const setRedirectUrl = (url: string) => setSessionStorageItem(keyRedirectUrl, url);

export const deleteRedirectUrl = () => deleteSessionStorageItem(keyRedirectUrl);

export const getCurrentRelativeUrl = () =>
  window.location.pathname + window.location.search + window.location.hash;

// Only same-origin relative paths: a leading "//" or "/" plus a backslash is cross-origin.
export const isSafeRedirectUrl = (url: string | null): url is string =>
  url !== null && /^\/(?![/\\])/.test(url);

export const getSafeRedirectUrl = () => {
  const url = getRedirectUrl();
  if (!isSafeRedirectUrl(url)) return null;
  try {
    const pathname = decodeURIComponent(new URL(url, window.location.origin).pathname)
      .replace(/\/+$/, "")
      .toLowerCase();
    return [pages.login, pages.logout, pages.setTokenCallback].includes(pathname) ? null : url;
  } catch {
    return null;
  }
};
